<template>
  <section class="cta-section">
    <!-- 内容 -->
    <div class="cta-content">

      <h2 class="cta-title">
       Let’s build something great, together
      </h2>

      <p class="cta-desc">
       Fast quotes, professional engineering support, and reliable sheet metal for your custom parts and projects.
      </p>

      <button class="cta-button" @click="$router.push('/quote')">
        Get Instant Quote
      </button>

      <div class="mini-text">
       
      </div>

    </div>
  </section>
</template>

<script>
export default {
  name: 'Sheet_together'
}
</script>

<style scoped>

/* ---------------- Reset ---------------- */

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* ---------------- Section ---------------- */

.cta-section {
  position: relative;
  overflow: hidden;
  text-align: center;
  background: #262626;
  padding: 60px 20px 60px;
  font-family:
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    Roboto,
    sans-serif;
}

/* ---------------- Content ---------------- */

.cta-content {
  position: relative;
  z-index: 10;

  max-width: 960px;
  margin: 0 auto;

  display: flex;
  flex-direction: column;
  align-items: center;
}

/* ---------------- Title ---------------- */

.cta-title {
  font-size: 3.4rem;
  line-height: 1.08;

  font-weight: 520;

  color: #fff;

  letter-spacing: -2px;

  margin-bottom: 22px;
}

.cta-title span {
  display: block;

  margin-top: 6px;

  font-size: 0.92em;

  font-weight: 420;

  color: #5f5f5f;
}

/* ---------------- Description ---------------- */

.cta-desc {
  max-width: 720px;

  font-size: 1.08rem;

  color: #fff;

  line-height: 1.75;

  letter-spacing: 0.15px;

  margin-bottom: 30px;
}

/* ---------------- Button ---------------- */

.cta-button {
  padding: 15px 38px;

  border: none;
  border-radius: 10px;

  background: #18b394;

  color: #ffffff;

  font-size: 1rem;
  font-weight: 600;

  cursor: pointer;

  transition: all 0.3s ease;

  box-shadow: 0 10px 30px rgba(24, 179, 148, 0.16);
}

.cta-button:hover {
  background: #15997f;
  transform: translateY(-2px);
}

/* ---------------- Mini Text ---------------- */

.mini-text {
  margin-top: 26px;

  font-size: 0.92rem;

  color: #8b8b8b;

  letter-spacing: 0.45px;

  line-height: 1.7;
}

/* ---------------- Responsive ---------------- */

@media (max-width: 768px) {

  .cta-section {
    padding: 110px 20px 100px;
  }

  .cta-title {
    font-size: 2.35rem;
    line-height: 1.12;
    letter-spacing: -1px;
  }

  .cta-title span {
    margin-top: 8px;
  }

  .cta-desc {
    font-size: 1rem;
    line-height: 1.65;

    margin-bottom: 36px;
  }

  .cta-button {
    padding: 13px 28px;
    font-size: 0.95rem;
  }

  .mini-text {
    font-size: 0.82rem;
    line-height: 1.6;

    padding: 0 10px;
  }

  /* Shapes Scale */

  .shape-cube-1,
  .shape-solid-cube,
  .shape-diamond,
  .shape-circle,
  .shape-cube-2 {
    transform: scale(0.68);
  }

  .shape-cube-1 {
    left: -70px;
  }

  .shape-solid-cube {
    right: -70px;
  }

  .shape-circle {
    left: 5%;
  }

  .shape-diamond {
    right: 8%;
  }
}

</style>